module.exports = __webpack_public_path__ + "img/bca0311d4178463853c3f73d3015e4b.3770a01d.jpg";